import { render, staticRenderFns } from "./VirementLemonway.vue?vue&type=template&id=3ae0fb9c&"
import script from "./VirementLemonway.vue?vue&type=script&lang=js&"
export * from "./VirementLemonway.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VirementLemonway.vue"
export default component.exports